import { faHeart as faHeartLight } from "@jewlr/pro-light-svg-icons/faHeart"
import { faSpinner } from "@jewlr/pro-regular-svg-icons/faSpinner"
import { faHeart as faHeartSolid } from "@jewlr/pro-solid-svg-icons/faHeart"
import PropTypes from "prop-types"
import { useEffect, useState } from "react"

import withWishlist from "areas/collection/hoc/with-wishlist"
import { openModal } from "components/modal"
import Button from "components/ui/button"
import FontAwesomeIcon from "components/ui/font-awesome-icon"
import { IS_JEWLR, isTestMode } from "helpers/application"

const WishlistIcon = ({
  confirmWishlist,
  isLoggedIn,
  setProductParams,
  toggleAddToWishlist,
  wishlistAdded,
  wishlistLoading,
}) => {
  const [loading, setLoading] = useState(false)

  const wishlistName = IS_JEWLR() ? "wish list" : "collection"
  const ariaLabel = loading
    ? `Loading ${wishlistName}`
    : isLoggedIn
      ? wishlistAdded
        ? `Remove from ${wishlistName}`
        : `Add to ${wishlistName}`
      : `Create a VIP account to add to your ${wishlistName}`

  useEffect(() => {
    if (!wishlistLoading) {
      setLoading(wishlistLoading)
    }
  }, [wishlistLoading])

  return (
    <Button
      aria-label={ariaLabel}
      className="z-1 absolute right-20 top-5"
      disabled={loading}
      id="col_add_to_wishlist"
      onClick={(e) => {
        if (!isTestMode) {
          dataLayer.push({ event: "clicked-wishlist-icon" })
        }

        if (!IS_JEWLR() || isLoggedIn) {
          if (!loading) {
            setLoading(true)
            toggleAddToWishlist(
              confirmWishlist,
              setProductParams,
              e,
              setLoading
            )
          }
        } else {
          openModal("#signup")
        }
      }}
      title={ariaLabel}
    >
      {loading ? (
        <FontAwesomeIcon className="text-20" icon={faSpinner} spin />
      ) : (
        <FontAwesomeIcon
          className={`text-24 ${
            wishlistAdded ? "text-wishlist" : "text-black"
          }`}
          icon={wishlistAdded ? faHeartSolid : faHeartLight}
        />
      )}
    </Button>
  )
}

WishlistIcon.propTypes = {
  confirmWishlist: PropTypes.func,
  isLoggedIn: PropTypes.bool,
  setProductParams: PropTypes.func,
  toggleAddToWishlist: PropTypes.func,
  wishlistAdded: PropTypes.bool,
  wishlistLoading: PropTypes.bool,
}

export default withWishlist(WishlistIcon)
